import { Schema as S } from "effect";

import { apiData } from "../../api/asyncData";
import { AdminDetail, AdminUsers } from "../../api/commands/admin";
import { Dialog } from "../../widgets/dialog";

export const Feedback = S.Struct({
	kind: S.Literals(["success", "error"]),
	message: S.String,
});
export type Feedback = typeof Feedback.Type;

export const Model = S.Struct({
	page: S.Literal("Admin"),
	search: S.String,
	users: apiData(AdminUsers).schema,
	/** The circle whose drawer is open. */
	selected: S.Option(S.String),
	detail: apiData(AdminDetail).schema,
	dialog: Dialog.Model,
	sending: S.Boolean,
	feedback: S.Option(Feedback),
	copied: S.Boolean,
});
export type Model = typeof Model.Type;
